import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const travisCi = defineConnector({
  identifier: "travisCi",
  name: "Travis CI",
  tagLine: "Hosted CI for open-source and private projects",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.travis-ci\\.(com|org)/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiToken,
        scheme: "token",
      },
    ]),
  steps: [
    {
      title: "Get your Travis CI API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Travis CI, go to **Settings** and copy your **API authentication token**. Alternatively, use the Travis CLI: `travis token`.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.travis-ci.com/user",
  },
});
